import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

import { PrimengModule } from '@modules/primeng.module';
import { LoginComponent } from './components/login/login.component';
import { SolicitarCadastroComponent } from './components/solicitar-cadastro/solicitar-cadastro.component';
import { EsqueciSenhaComponent } from './components/esqueci-senha/esqueci-senha.component';

@NgModule({
  declarations: [LoginComponent, SolicitarCadastroComponent, EsqueciSenhaComponent],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    RouterModule,
    PrimengModule,
  ],
})
export class LoginModule {}
